import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AchievementsHook } from '../../../../hooks/useAchievements'
import { BadgeHook } from '../../../../hooks/useBadges'
import { ScoreboardHook } from '../../../../hooks/useScoreboard'
import { TimePeriodData } from '../../../../types/timePeriodData'
import { getScoreboardCardsByPeriod } from '../../../../utils/scoreboard/getScoreboardCardsByPeriod'
import ScoreboardCard from '../../scoreboardCard/ScoreboardCard'

interface ScoreboardGridProps {
	periodIndex: number
	timePeriods: TimePeriodData[]
	data: ScoreboardHook
	achievementsHook: AchievementsHook
	badgeHook: BadgeHook
}

const ScoreboardGrid: FC<ScoreboardGridProps> = ({
	periodIndex,
	timePeriods,
	data,
	achievementsHook,
	badgeHook,
}) => {
	const { t } = useTranslation('pages_saving')

	const period = timePeriods[periodIndex].id

	const periodCards = getScoreboardCardsByPeriod(period, data, achievementsHook, badgeHook, t)

	return (
		<div className='grid grid-cols-2 xl:grid-cols-4 gap-4'>
			{periodCards.map((card: any, i: number) => (
				<ScoreboardCard
					key={`${periodIndex}-${card.id || card.type}-${i}`}
					{...card}
					isLoading={data.isLoading}
				/>
			))}
		</div>
	)
}

export default ScoreboardGrid
